<template>
  <modal :show="show" header-classes="justify-content-center center" @close="handleClose()">
    <template>
      <el-table
        :data="tableData"
        stripe
      >
        <el-table-column prop="metric" label="Metric" />
        <el-table-column prop="calculation" label="Calculation" />
      </el-table>
    </template>
  </modal>
</template>

<script>

import modal from '../../components/UIComponents/Modal';

export default {
    name: 'MetricModal',
    components: {
        modal
    },
    data() {
        return {
            tableData: [
                {
                    metric: 'Monthly BS Reporting %',
                    calculation: 'Percent of bible study meetings in the past 38 days that were reported'
                },
                {
                    metric: 'BSPx1',
                    calculation: 'Number of students who have come to at least one bible study since Aug 1'
                },
                {
                    metric: 'BSPx4',
                    calculation: 'Number of students who have come to 4 or more bible studies since Aug 1'
                },
                {
                    metric: 'Growing Disciples',
                    calculation:
                    'Number of growing disciples (does NOT include commissioned, DMs, or SMs)'
                },
                {
                    metric: 'Commissioned Disciples',
                    calculation:
                    'Number of commissioned disciples (does NOT include growing; DOES include DMs + SMs)'
                },
                {
                    metric: 'All SLBS',
                    calculation:
                    'Number of students leading bible studies that are not ended'
                },
                {
                    metric: 'Active SLBS',
                    calculation:
                    'Number of students leading bible studies with at least one attendee in the past 38 days'
                },
                {
                    metric: 'Growing Disciple Makers',
                    calculation:
                    'Number of students leading one or more growing disciples'
                },
                {
                    metric: 'Disciple Makers',
                    calculation: 'Number of students leading at least one commissioned disciple'
                }
            ]
        };
    },
    props: {
        show: Boolean
    },
    computed: {
    },
    methods: {
        handleClose() {
            this.$emit('close');
        },
    },
};

</script>
